import React from 'react';
import { Star } from 'lucide-react';
import { useWatchlistContext } from '@/contexts/WatchlistContext';
import type { WatchedSnapshot } from '@/lib/watchlistStorage';

interface WatchButtonProps {
  domain: string;
  snapshot: WatchedSnapshot;
  className?: string;
  onToast?: (msg: string) => void;
}

const WatchButton: React.FC<WatchButtonProps> = ({ domain, snapshot, className = '', onToast }) => {
  const { isWatched, toggle } = useWatchlistContext();
  const watched = isWatched(domain);

  const handleClick = (e: React.MouseEvent) => {
    e.stopPropagation();
    const result = toggle(domain, snapshot);
    if (!result.ok) {
      if (result.reason === 'full') {
        onToast?.('Watchlist full — remove items to add more.');
      } else {
        onToast?.("Couldn't save — your browser may be blocking storage.");
      }
    }
  };

  return (
    <button
      onClick={handleClick}
      title={watched ? `Remove ${domain} from watchlist` : `Watch ${domain}`}
      className={`flex items-center gap-1 px-2 py-1 rounded text-xs font-semibold transition-colors ${
        watched
          ? 'text-yellow-500 hover:text-yellow-600 bg-yellow-50 hover:bg-yellow-100'
          : 'text-gray-400 hover:text-yellow-500 hover:bg-yellow-50'
      } ${className}`}
    >
      <Star className={`h-3.5 w-3.5 ${watched ? 'fill-yellow-400 text-yellow-400' : ''}`} />
      <span>{watched ? 'Watching' : 'Watch'}</span>
    </button>
  );
};

export default WatchButton;
